/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Tuda_Zwei_Mal_Pro_Monat19Inputs */

const en__field_enum_tuda_zwei_mal_pro_monat19 = /** @type {(inputs: _Field_Enum_Tuda_Zwei_Mal_Pro_Monat19Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`twice a month`)
};

const de__field_enum_tuda_zwei_mal_pro_monat19 = /** @type {(inputs: _Field_Enum_Tuda_Zwei_Mal_Pro_Monat19Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`zwei mal im Monat`)
};

/**
* | output |
* | --- |
* | "twice a month" |
*
* @param {_Field_Enum_Tuda_Zwei_Mal_Pro_Monat19Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_tuda_zwei_mal_pro_monat19 = /** @type {((inputs?: _Field_Enum_Tuda_Zwei_Mal_Pro_Monat19Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Tuda_Zwei_Mal_Pro_Monat19Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_tuda_zwei_mal_pro_monat19(inputs)
	return de__field_enum_tuda_zwei_mal_pro_monat19(inputs)
});
export { _field_enum_tuda_zwei_mal_pro_monat19 as "_field_enum_TUDA_ZWEI_MAL_PRO_MONAT" }